/**
 * Tool-card registrations for the Knowledge Base agent destination.
 *
 * Registers against the tailwind-v4 PACKAGE-LEVEL singleton registry
 * (`tailwind-v4/blocks/agent-chat`'s `registerTool`), not the separate
 * app-local registry the old `/chat` page keeps in
 * `pages/[org_id]/chat/utils/tool-registry.ts` — that one is a distinct,
 * disconnected object only wired up via a Context provider on `/chat`'s own
 * tree. `ToolCallCard` (packages/tailwind-v4/.../tool-call-card.tsx) checks
 * a context-supplied registry first and falls back to this package
 * singleton — so registering here works from ANY page, including this one,
 * with zero extra provider wiring.
 *
 * Import `initKnowledgeBaseToolRegistrations()` once from the Knowledge Base
 * page component (and use its return value, e.g. log/ignore it) so the
 * bundler can't tree-shake this file's side effects away.
 */
import { registerTool } from 'tailwind-v4/blocks/agent-chat'
import { getRegisteredToolNames } from 'tailwind-v4/blocks/agent-chat'
import { searchKnowledgeToolRenderer } from './search-knowledge-card'

registerTool(['searchKnowledge', 'search-knowledge'], searchKnowledgeToolRenderer)

export function initKnowledgeBaseToolRegistrations(): number {
  return getRegisteredToolNames().length
}
